import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
})
export class MenuComponent implements OnInit {
  public foto
  public nombre
  public correo: any;
  public role
  constructor( private auth:AuthService,private authing:AngularFireAuth) {
    this.sessionData()
   }


  ngOnInit() {}
 logout(){
   this.auth.onLogout()

 }
 support(){
   
 }
 sessionData(){
  this.authing.auth.onAuthStateChanged(k=>{
     this.auth.datosPefilSesion(k.uid).subscribe(o=>{
         this.foto=o.data()['foto']
         this.nombre=o.data()['nombre']
         this.correo=o.data()['email']
         this.role=o.data()['role']
     })

  })
 }
}
